<template>
  <a-modal width="40%" :title="$t('global.resetPassword')" @cancel="cancel" v-model="visable" centered @ok="handleOk" destroyOnClose>
    <a-form :form="resetPasswordForm">
      <a-form-item :label="$t('global.oldPassword')" v-bind="formItemLayout">
        <a-input
          size="small"
          type="password"
          v-model="oldPassword" 
          v-decorator="[
            'oldPassword',
            { rules:
              [
                {required: true, message: $t('global.oldPasswordTip')},
                {max:15,message:$t('global.passwordLengthTip')},
                {min:6,message:$t('global.passwordLengthTip')},
              ]
            }
          ]">
        </a-input>
      </a-form-item>
      <a-form-item :label="$t('global.newPassword')" v-bind="formItemLayout">
        <a-input size="small" type="password" v-model="password" v-decorator="['password',{ rules: [
                        { required: true, message: $t('global.newPasswordTip') },
                        {max:15,message:$t('global.passwordLengthTip')},
                        {min:6,message:$t('global.passwordLengthTip')},
                        ] }]"></a-input>
      </a-form-item>

      <a-form-item :label="$t('global.confirmPassword')" v-bind="formItemLayout">
        <a-input size="small" type="password" v-model="passwordConfirm"
          v-decorator="['passwordConfirm',{ rules: [{ required: true, message: $t('global.confirmPasswordTip') },{ validator: checkPasswordConfirm }] }]">
        </a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
  import {httpModel} from '../../http/httpModel'
  export default {
    data() {
      return {
        visable: true,
        password: '',
        passwordConfirm: '',
        resetPasswordForm: '',
        oldPassword: '',
        formItemLayout: {
          labelCol: {
            span: 6
          },
          wrapperCol: {
            span: 17
          }
        }
      }
    },
    methods: {
      handleOk() {
        // ..
        // console.log(this.resetPasswordForm)
        this.resetPasswordForm.validateFieldsAndScroll((error, values) => {
          if (error) return
          // console.log(values)
          let param = {
            password: values.oldPassword,
            new_password: values.password
          }
          httpModel.resetPassword(param).then((res) => {
            // console.log(res)
            this.$notification.success({
              message: '重置密码成功！'
            })
            // todo...
            this.$emit('quit')
          })
        })
      },
      cancel () {
        // this.visable = false
        this.$emit('quit')
      },
      checkPasswordConfirm(rule, value, callback) {
        if (this.password == this.passwordConfirm) {
          callback()
          return
        }
        callback(this.$t('global.confirmError'));
      },
    },
    created() {
      this.resetPasswordForm = this.$form.createForm(this)
    }
  }
</script>
<style lang="less" scoped>

</style>